import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavClick = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <footer className="bg-[#2C3E2F] text-white py-12 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_biofab-labs/artifacts/ynofsip9_Punarvibes_Logo.png" 
              alt="Punarvibes Logo" 
              className="h-24 w-auto mb-4"
            />
            <p className="text-sm text-white/70">
              Next Gen Bio-Materials
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><button onClick={() => handleNavClick('/about')} className="hover:text-white transition-colors">About Us</button></li>
              <li><button onClick={() => handleNavClick('/products')} className="hover:text-white transition-colors">Our Products</button></li>
              <li><button onClick={() => handleNavClick('/contact')} className="hover:text-white transition-colors">Contact</button></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Focus Areas</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>Urban Waste Upcycling</li>
              <li>Agri-Waste Valorization</li>
              <li>Textile Transformation</li>
              <li>Biomaterial Innovation</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><button onClick={() => handleNavClick('/contact')} className="hover:text-white transition-colors">Contact Us</button></li>
              <li><button onClick={() => handleNavClick('/contact')} className="hover:text-white transition-colors">Partnerships</button></li>
              <li><button onClick={() => handleNavClick('/careers')} className="hover:text-white transition-colors">Careers</button></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center text-sm text-white/70">
          <p>© 2025 Punarvibes Pvt Ltd. All rights reserved. | Incorporated June 2025, Bengaluru</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
